import * as React from 'react';
const styles = require('./TabContents.pcss');

interface IProps {
    activeContent : number;
}

export class TabContents extends React.Component<IProps, {}>{
    render() {
        let { activeContent } = this.props;        

        return (
            <ul className={styles.container}>
                {React.Children.map(this.props.children, (child, index) => {

                    let activeClass = index == activeContent ? styles.active : '';
                    return <li key={index} className={`${styles.content} ${activeClass}`}>{child}</li>

                })}
            </ul>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/TabContents/TabContents.tsx